import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

// require('foundation-sites');
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces-app-corp';

// REQUIRED
import './global/no-js-check';
import './global/u-menu-native';
// REQUIRED LIBRARIES

// REQUIRED COMPONENTS
import './components/c-feature-carousel';
import './components/c-card-carousel-alpha';
import './components/c-filter';
import './components/c-breadcrumb';
import './components/c-card-pricing-compact-listing';
import './components/c-image-inline';
import './components/c-tabs';
import './components/c-card-pricing-list';
import './components/e-data-input'
import './components/c-navigation-contents'
// Must be last

$(document).ready(function() {
    $(document).foundation();
});